export default {
    guider: {
        title: 'Get help with:',
        more: 'Access the Help Center to discover useful articles and tips to help guide you.',
    },
};
